import React from "react";
import { RouteComponentProps, withRouter, useLocation } from "react-router-dom";
import { InterventoNew } from "./InterventoForm";
import { links } from "../../routes";
import { CustomerData } from "../../customers/components/CustomerData";
import { InterventoComponent } from "./InterventiHelpers";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const InterventoNewPage = withRouter((props: RouteComponentProps) => {

    const { history } = props;

    const query = useQuery();
    const idImpianto = query.get("idImpianto");
    const idCliente = query.get("idCliente");
    const from = query.get("from");
    const to = query.get("to");

    return (<div className="card">
        <div className="card-header bg-theme d-flex align-items-center">
            <div className="flex-fill">
                <h3 className="text-white mb-0 text-truncate">
                    Nuovo Intervento
                </h3>
            </div>
        </div>
        <div className="card-body">
            <InterventoNew
                idCliente={idCliente ? +idCliente : null}
                idImpianto={idImpianto ? +idImpianto : null}
                from={from ? new Date(from) : undefined}
                to={to ? new Date(to) : undefined}
                afterSave={intervento => history.replace(links.interventoEdit(intervento.idCliente!, intervento.idIntervento))}
                onCancel={() => history.goBack()}
            />
        </div>
    </div>);
})



export const InterventoEditPage = withRouter((props: RouteComponentProps<{ id: string, idCliente: string }>) => {

    const { history, match: { params: { id, idCliente: idClienteStr } } } = props;

    if (!id || !idClienteStr) {
        history.goBack();
        return null;
    }
    const query = useQuery();
    const idImpianto = query.get("idImpianto");
    return (
        <div className="card">
            <div className="card-header bg-theme d-flex align-items-center">
                <div className="flex-fill">
                    <h3 className="text-white mb-0 text-truncate">
                        <>
                            <CustomerData
                                id={+idClienteStr}
                                template={x => `Intervento di ${x.nomeProprietario} ${x.cognomeProprietario}`} />
                        </>
                    </h3>
                </div>
            </div>
            <div className="card-body">
                <InterventoComponent
                    onCancel={() => history.goBack()}
                    idCliente={+ idClienteStr}
                    idImpianto={idImpianto ? +idImpianto : undefined}
                    id={+id}
                    afterSave={intervento => id ? () => { } : history.replace(links.interventoEdit(+idClienteStr, intervento.idIntervento))}
                    afterDelete={() => history.replace(links.customerShow(+idClienteStr))}
                />
            </div>
        </div>
    );
})